import { palette } from '@shared/tokens/palette.stylex';
import { FC } from 'react';

interface NoSymbolIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const NoSymbolIcon: FC<NoSymbolIconProps> = ({
  color = palette['grey-300'],
  size = '16',
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.48032 3.77321L12.2268 11.5197C14.0304 9.35886 13.9178 6.13962 11.8891 4.11091C9.86038 2.08221 6.64114 1.96964 4.48032 3.77321ZM11.5197 12.2268L3.77321 4.48032C1.96964 6.64114 2.08221 9.86038 4.11091 11.8891C6.13962 13.9178 9.35886 14.0304 11.5197 12.2268ZM3.40381 3.40381C5.94221 0.865398 10.0578 0.865398 12.5962 3.40381C15.1346 5.94221 15.1346 10.0578 12.5962 12.5962C10.0578 15.1346 5.94221 15.1346 3.40381 12.5962C0.865398 10.0578 0.865398 5.94221 3.40381 3.40381Z"
      fill={color}
    />
  </svg>
);
